import { TableCell } from '@e2n/ui';
import { Data } from '@/domain/controlling/entities/historie';
import {
  AbweichungIcon,
  MoneyField,
} from '@/domain/controlling/pages/Umsatzplanung/components';
import { useTranslation } from 'react-i18next';

export function UmsatzCell({
  tagebuchData,
}: {
  tagebuchData: Data | undefined;
}) {
  const { t } = useTranslation();

  return (
    <TableCell className="font-medium py-4 ps-4">
      <div className="flex gap-2 items-center">
        <MoneyField
          value={tagebuchData?.istUmsatz?.wert}
          unit={t('general.currency.EUR')}
        />
        {tagebuchData?.planUmsatz?.wert && (
          <AbweichungIcon
            baseValue={tagebuchData?.istUmsatz?.wert?.amount}
            comparisonValue={tagebuchData?.planUmsatz?.wert?.amount}
          />
        )}
      </div>
    </TableCell>
  );
}
